export const DOCUMENT_TYPES = [
  { reportType: 'DrugAlcoholTest', displayName: 'DRUG TEST REPORT' },
  { reportType: 'Abstract', displayName: 'MVR/ ABSTRACT' },
  { reportType: 'PoliceClearance', displayName: 'Criminal Record (Background) Check' },
  { reportType: 'PreEmploymentScreening', displayName: 'PRE EMPLOYMENT REPORT' },
  { reportType: 'ClearingHouseReport', displayName: 'CLEARING HOUSE REPORT' },
  { reportType: 'declarationForm', displayName: 'Declaration' },
  { reportType: 'EmploymentHistoryCheck', displayName: 'Employment History Check' }
];
